import { captureMessage } from '@fourthwall/sentry'
import type { ConfirmMediaResponse } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { useMutation } from '@tanstack/react-query'

const MAX_ITERATIONS = 20

export const useCheckMediaCreatedMutation = () => {
  const pollMediaData = async (
    iteration: number,
    postId: number,
  ): Promise<ConfirmMediaResponse> => {
    const mediaData = await MembershipsCreatorApiClient.confirmMediaUpload(postId)

    if (mediaData.data.status !== 'Created') {
      return mediaData.data
    }

    if (iteration === MAX_ITERATIONS) {
      captureMessage("Couldn't confirm Mux media upload", {
        extra: { postId },
      })

      return mediaData.data
    }

    await new Promise((resolve) => {
      setTimeout(resolve, 1000)
    })

    return await pollMediaData(iteration + 1, postId)
  }

  const checkMediaCreatedMutation = useMutation({
    mutationFn: async (postId: number) => {
      return await pollMediaData(0, postId)
    },
  })

  return {
    checkMediaCreatedMutation,
  }
}
